import React, { useEffect, useRef } from 'react';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function TextArea({
  label,
  charCount,
  maxCount,
  placeholder,
  fromForm,
  duplicatingItem,
  pageIndex,
  gridIndex,
  disable,
  value,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  fontSize,
  localPageState,
  rowHeight,
  mergeWithExistingData,
  setLayout,
  onHeightChange,
  gridW,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  let style = {};
  const styleInput = fontSize?.value ? { fontSize: `${fontSize?.value}px` } : { fontSize: '11px' };
  const combinedStyles = getControlStyle(otherConfiguration);
  if (styleInput) {
    style = { ...combinedStyles, ...styleInput };
  }
  const textareaRef = useRef(null);
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // Reset height to auto
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 5}px`; // Set height based on scrollHeight
      // textareaRef.current.style.height = "100%";
      if (textareaRef.current.scrollHeight > 0) {
        onHeightChange(textareaRef.current.scrollHeight);
      }
    }
  };

  useEffect(() => {
    if (gridW) {
      adjustTextareaHeight();
    }
  }, [gridW]);

  return (
    <div>
      <textarea
        ref={textareaRef}
        name={label}
        id={label}
        disabled={disable}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target, label, gridIndex, pageIndex);
          adjustTextareaHeight();
        }}
        value={value}
        style={style}
        className="form-control overflow-y-hidden min-h-38"
      />
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
      {charCount && <div className="text-count">0/{maxCount}</div>}
    </div>
  );
}
export default TextArea;
